import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Menu } from '@Common/neo-components/neo-home/models/menu.model';
import {VideoModalComponent} from "../video-modal/video-modal.component";


@Component({
  selector: 'app-home-boutons-applicant',
  templateUrl: './home-boutons-applicant.component.html',
  styleUrls: ['./home-boutons-applicant.component.scss']
})
export class HomeBoutonsApplicantComponent implements OnInit {
  boutons: Menu[] = [{
    titre: 'Vos versements',
    icon: 'source',
    url: '/versement',
    nav: false
  }, {
    titre: 'Vos demandes de consultation',
    icon: 'find_in_page',
    url: '/consultation',
    nav: false
  }];

  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
  }
  openVideoModal(): void {
    this.dialog.open(VideoModalComponent, {
      width: '800px',
      maxWidth: '90vw',
      maxHeight: '90vh',
      panelClass: 'video-modal-container',
      disableClose: true
    });
  }
}
